/* __next_internal_client_entry_do_not_use__ UserPerceivedLoadTimingContext auto */ import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import * as React from "react";
export var UserPerceivedLoadTimingContext = /*#__PURE__*/ React.createContext({
    refCallback: emptyRefCallback,
    refCallbackWithOptions: emptyRefCallback,
    numComponents: undefined,
    renderNonPrimaryContentPromise: new Promise(function() {})
});
var _createContextStore = createContextStore({
    numComponentsPerClientSize: undefined
}, {
    name: "UserPerceivedLoadTimingLoadedStore"
});
export var useUPLTLoadedStore = _createContextStore.useStore, UPLTLoadedStoreProvider = _createContextStore.Provider;
function emptyRefCallback() {}
